import type { TPAComponentProps, RequiredProps } from '../../types';
import { CoreButtonProps } from '../internal/WixUiCoreComponents/components/CoreButton';
import type { Placement } from '../internal/WixUiCoreComponents/components/CorePopover';

export enum CounterSize {
  medium = 'medium',
  xSmall = 'xSmall',
}

export interface CounterProps extends TPAComponentProps, RequiredProps {
  onChange(val: string): void;
  /** Accessible label for the increment button */
  incrementAriaLabel?: string;
  /** Accessible label for the decrement button */
  decrementAriaLabel?: string;
  inputAriaLabel: string;
  ['aria-labelledby']?: string;
  ['aria-label']?: string;
  ['aria-describedby']?: string;
  value: number;
  step: number;
  min?: number;
  max?: number;
  error?: boolean;
  disabled?: boolean;
  /** the error message to display */
  errorMessage?: string;
  /** Specifies whether to apply the new design and behavior of error messages */
  newErrorMessage?: boolean;
  /** error tooltip max width */
  errorTooltipMaxWidth?: number;
  /** Placement for Popover. Optional. */
  errorTooltipPlacement?: Placement;
  size?: CounterSize;
  label?: string;
  steppersType?: CoreButtonProps['type'];
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

export interface CounterDefaultProps {
  step: number;
  value: number;
  size: CounterSize;
  errorTooltipPlacement: Placement;
}

export interface CounterState {
  focused: boolean;
  isErrorTooltipShown: boolean;
  errorIconClicked: boolean;
  isWithinRoot: boolean;
}
